import React from 'react';
import { api, extractErr } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

// Asks for an email and always shows the same "check your inbox" message (no account enumeration).
export function ForgotPasswordForm({ onBack }) {
  const [email, setEmail] = React.useState('');
  const [busy, setBusy] = React.useState(false);
  const [done, setDone] = React.useState('');
  const [err, setErr] = React.useState('');
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr('');
    try { const { data } = await api.post('/auth/forgot-password', { email: email.trim() }); setDone(data.message); }
    catch (x) { setErr(extractErr(x, 'Could not send the link. Try again.')); } finally { setBusy(false); }
  };
  return (
    <div data-testid="forgot-password-view">
      <h2 className="font-serif text-3xl text-[#1D1D1F]">Reset password</h2>
      <p className="mt-1 text-sm text-slate-500">We'll email you a link to choose a new one.</p>
      {done ? (
        <div className="mt-8 rounded-xl bg-white border border-black/5 p-4 text-sm text-[#1D1D1F]" data-testid="forgot-password-sent">
          {done} The link expires in 30 minutes. Check your spam folder if it doesn't arrive.
        </div>
      ) : (
        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <Label htmlFor="forgot-email" className="text-xs uppercase tracking-wide text-slate-500">Email</Label>
            <Input id="forgot-email" type="email" required autoCapitalize="none" spellCheck={false} value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 bg-white" data-testid="forgot-password-email" />
          </div>
          {err && <p className="text-sm text-red-600" data-testid="forgot-password-error">{err}</p>}
          <Button type="submit" disabled={busy} className="w-full bg-[#1D1D1F] hover:bg-[#2C2C2E] text-white" data-testid="forgot-password-submit">{busy ? 'Sending\u2026' : 'Send reset link'}</Button>
        </form>
      )}
      <button type="button" onClick={onBack} className="mt-6 text-xs text-slate-500 hover:text-[#1D1D1F] transition-colors" data-testid="forgot-password-back">← Back to sign in</button>
    </div>
  );
}
